export interface FirebaseEnvironment {
  apiKey: string;
  authDomain: string;
  projectId: string;
  messagingSenderId: string;
  appId: string;
  storageBucket: string;
}
export const firebaseEnvironment: FirebaseEnvironment = {
  apiKey: 'AIzaSyBpORoYY2_VodgP9E8T4NRsy6tKCgTOYgQ',
  authDomain: 'meplis-cnp.firebaseapp.com',
  projectId: 'meplis-cnp',
  storageBucket: 'meplis-cnp.firebasestorage.app',
  messagingSenderId: '833741800012',
  appId: '1:833741800012:web:9de50dba4d2c6f9c8feae9',
};
